export default __webpack_public_path__ + "712b88997168fd1515de92a2db1b371e.png";